// import TweenLite from './vendor/TweenLite';
// import { qs, qsArray } from './utilities/selectors';
import {qs, qsArray, isInternetExplorer, isEdge, trackEvent} from './utilities/index';
import Application from "./application";
import Slider from "./slider";

let Questions = function (params) {
  // console.log('Questions initalizing ' + params);

  /**
   *
   */
  let self = this;
  let sectionElement = document.getElementById('application');
  let backgroundElement = document.getElementById('questions-bg');
  let headerElement = document.getElementById('questions-header');
  let playerElement = document.getElementById('player');
  let clubheadsElement = document.getElementById('clubheads');
  let pathsElement = document.getElementById('paths');
  let landingSpotElement = document.getElementById('landing-spot');
  let questionsElement = document.getElementById('sliders');
  let submitButton = document.getElementById('submit-button');
  let mobileSubmitButton = document.getElementById('mobile-submit-button');
  let mobileControls = document.getElementById('mobile-controls');
  // q1 distance slider
  this.slider1 = new Slider({elementId: 'q1-slider', mobileCircleId: 'q1-distance-circle'});
  // q2 flight slider
  this.slider2 = new Slider({elementId: 'q2-slider', mobileCircleId: 'q2-flight-circle'});
  // q3 clubhead slider
  this.slider3 = new Slider({elementId: 'q3-slider', mobileCircleId: 'q3-clubhead-circle'});
  // q4 accuracy consistency slider
  this.slider4 = new Slider({elementId: 'q4-slider', mobileCircleId: 'q4-accuracy-circle'});

  // let mobileControls = document.getElementById('mobile-controls');
  // let slider1Circle = mobileControls.querySelector('#q1-distance-circle');
  // let slider2Circle = mobileControls.querySelector('#q2-flight-circle');
  // let slider3Circle = mobileControls.querySelector('#q3-clubhead-circle');
  // let slider4Circle = mobileControls.querySelector('#q4-accuracy-circle');

  let timeline;
  let playerTween = null;
  let panelTween = null;

  this.open = function() {
    console.log('Questions.open');
    sectionElement.style.display = 'block';
    TweenLite.set([playerElement, pathsElement, questionsElement, landingSpotElement, mobileControls, mobileSubmitButton], {opacity: 0});
    TweenLite.set([questionsElement], {transform: 'translateX(100px)'});
    timeline = new TimelineLite({onComplete: this.openComplete, onCompleteScope: this});
    timeline.to([backgroundElement, headerElement, playerElement, pathsElement, landingSpotElement], 0.75, {opacity: 1});
    timeline.to([mobileControls, mobileSubmitButton], .5, {opacity: 1}, '-=0.25');
    timeline.to([questionsElement], .5, {opacity: 1, transform: 'translateX(0)'}, "-=0.5");

    timeline.play();
  };

  this.openComplete = function () {
    console.log('Questions.openComplete');
    this.slider1.initialize();
    this.slider2.initialize();
    this.slider3.initialize();
    this.slider4.initialize();
    this.initializeSubmitButton();
  };

  this.closeAllSliders = function () {
    this.slider1.closeMobileSlider();
    this.slider2.closeMobileSlider();
    this.slider3.closeMobileSlider();
    this.slider4.closeMobileSlider();
  };

  this.setPath = function () {
    let allPaths = pathsElement.querySelectorAll('.path');
    for (let x = 0; x < allPaths.length; x++) {
      allPaths[x].classList.remove('selected');
    }
    let flight = this.slider2.getFlight();
    let distance = this.slider1.getDistance();
    let className = '.' + flight + '-' + distance;
    let path = pathsElement.querySelector(className);
    path.classList.add('selected');
    document.getElementById('clubheads').classList.remove('selected');
    console.log('selected path name is ' + className);

    let flightCircle = document.getElementById('q2-flight-circle');
    flightCircle.classList.remove('high-200');
    flightCircle.classList.remove('high-210');
    flightCircle.classList.remove('high-220');
    flightCircle.classList.remove('high-230');
    flightCircle.classList.remove('high-240');
    flightCircle.classList.remove('high-250');
    flightCircle.classList.remove('high-260');
    flightCircle.classList.remove('high-270');
    flightCircle.classList.remove('high-280');
    flightCircle.classList.remove('high-290');
    flightCircle.classList.remove('high-300');
    flightCircle.classList.remove('medium-200');
    flightCircle.classList.remove('medium-210');
    flightCircle.classList.remove('medium-220');
    flightCircle.classList.remove('medium-230');
    flightCircle.classList.remove('medium-240');
    flightCircle.classList.remove('medium-250');
    flightCircle.classList.remove('medium-260');
    flightCircle.classList.remove('medium-270');
    flightCircle.classList.remove('medium-280');
    flightCircle.classList.remove('medium-290');
    flightCircle.classList.remove('medium-300');
    flightCircle.classList.remove('low-200');
    flightCircle.classList.remove('low-210');
    flightCircle.classList.remove('low-220');
    flightCircle.classList.remove('low-230');
    flightCircle.classList.remove('low-240');
    flightCircle.classList.remove('low-250');
    flightCircle.classList.remove('low-260');
    flightCircle.classList.remove('low-270');
    flightCircle.classList.remove('low-280');
    flightCircle.classList.remove('low-290');
    flightCircle.classList.remove('low-300');
    flightCircle.classList.add(flight + '-' + distance);

    let distanceCircle = document.getElementById('q1-distance-circle');
    distanceCircle.classList.remove('low');
    distanceCircle.classList.remove('medium');
    distanceCircle.classList.remove('high');
    distanceCircle.classList.add(flight);

  };

  this.setClubhead = function () {
    let allHeads = clubheadsElement.querySelectorAll('.clubhead');
    for (let x = 0; x < allHeads.length; x++) {
      allHeads[x].classList.remove('selected');
    }
    let clubhead = this.slider3.getValue();
    if (clubhead === '2' || clubhead === '3')
    {
      let element = clubheadsElement.querySelector('#clubhead-' + clubhead);
      element.classList.add('selected');
      document.getElementById('clubheads').classList.add('selected');
    } else {
      document.getElementById('clubheads').classList.remove('selected');
    }

  };

  this.setLandingSpot = function () {
    let consistency = this.slider4.getValue();
    let distance = this.slider1.getDistance();
    landingSpotElement.classList.remove('size-1');
    landingSpotElement.classList.remove('size-2');
    landingSpotElement.classList.remove('size-3');
    landingSpotElement.classList.remove('distance-200');
    landingSpotElement.classList.remove('distance-210');
    landingSpotElement.classList.remove('distance-220');
    landingSpotElement.classList.remove('distance-230');
    landingSpotElement.classList.remove('distance-240');
    landingSpotElement.classList.remove('distance-250');
    landingSpotElement.classList.remove('distance-260');
    landingSpotElement.classList.remove('distance-270');
    landingSpotElement.classList.remove('distance-280');
    landingSpotElement.classList.remove('distance-290');
    landingSpotElement.classList.remove('distance-300');
    landingSpotElement.classList.add('size-' + consistency);
    landingSpotElement.classList.add('distance-' + distance);

    let accuracyCircle = document.getElementById('q4-accuracy-circle');
    accuracyCircle.classList.remove('distance-200');
    accuracyCircle.classList.remove('distance-210');
    accuracyCircle.classList.remove('distance-220');
    accuracyCircle.classList.remove('distance-230');
    accuracyCircle.classList.remove('distance-240');
    accuracyCircle.classList.remove('distance-250');
    accuracyCircle.classList.remove('distance-260');
    accuracyCircle.classList.remove('distance-270');
    accuracyCircle.classList.remove('distance-280');
    accuracyCircle.classList.remove('distance-290');
    accuracyCircle.classList.remove('distance-300');
    accuracyCircle.classList.add('distance-' + distance);
  };

  this.initializeSubmitButton = function () {
    submitButton.addEventListener('click', this.submitClicked);
    mobileSubmitButton.addEventListener('click', this.submitClicked);
  };

  this.disableSubmitButton = function () {
    submitButton.removeEventListener('click', this.submitClicked);
    mobileSubmitButton.removeEventListener('click', this.submitClicked);
  };


  this.submitClicked = function (event) {
    console.log('Questions.submitClicked!');
    window.driverSelector.calculateResults();
    // // close it up
    var slider2Val = window.driverSelector.questions.slider2.getValue();
    var slider3Val = window.driverSelector.questions.slider3.getValue();
    var slider4Val = window.driverSelector.questions.slider4.getValue();

    switch(slider2Val)
    {
      case "1":
        slider2Val = "low";
        break;
      case "2":
        slider2Val = "medium";
        break;
      case "3":
        slider2Val = "large";
        break;
    }

    switch(slider3Val)
    {
      case "1":
        slider3Val = "notsure";
        break;
      case "2":
        slider3Val = "modern";
        break;
      case "3":
        slider3Val = "traditional";
        break;
    }

    switch(slider4Val)
    {
      case "1":
        slider4Val = "notvery";
        break;
      case "2":
        slider4Val = "somewhat";
        break;
      case "3":
        slider4Val = "very";
        break;
    }

    self.close();
     trackEvent('answer', 'slider1', window.driverSelector.questions.slider1.getValue());
     trackEvent('answer', 'slider2', slider2Val);
     trackEvent('answer', 'slider3', slider3Val);
     trackEvent('answer', 'slider4', slider4Val);
     trackEvent('navigation', 'Next');
  };

  this.close = function () {
    console.log('Questions.close');
    this.disableSubmitButton();

    timeline = new TimelineLite({onComplete: self.closeComplete, onCompleteScope: self});
    timeline.to([mobileControls, mobileSubmitButton], .5, {opacity: 0});
    timeline.to([questionsElement], .5, {opacity: 0, transform: 'translateX(100px)'}, '-=0.5');
    timeline.to([headerElement, backgroundElement, playerElement, pathsElement, landingSpotElement], .5, {opacity: 0});

    timeline.play();

  };

  this.closeComplete = function() {
    console.log('Questions.closeComplete');
    timeline.kill();
    timeline = null;
    sectionElement.style.display = 'none';
    window.driverSelector.questionsClosed();
  }

};

export default Questions;

